import { create } from "zustand";
import { api } from "@/api/axios";

interface AuthState {
  user: { id: number; username: string; is_admin: boolean; email?: string; email_verified?: boolean } | null;
  setUser: (user: AuthState["user"]) => void;
  logout: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  logout: async () => {
    set({ user: null });
    try {
      await api.post("/api/auth/logout");
    } catch (e) {
      console.error("Logout request failed", e);
    } finally {
      window.location.href = "/login";
    }
  },
}));
